import { ButtonKVBase } from '@/presentation/components';
import { IconCircleCheck2 } from '@/presentation/components/icons';
import React, { useEffect } from 'react';
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { manageTeachersState, teacherForm } from '../atoms';
import Styles from './success-modal-styles.scss';
const SuccessModal = () => {
    const [state, setState] = useRecoilState(manageTeachersState);
    const formState = useRecoilValue(teacherForm);
    const resetState = useResetRecoilState(teacherForm);
    useEffect(() => {
        if (state.isSuccessModalVisible) {
            document.body.style.overflow = 'hidden'; // Avoid scroll
        }
        else {
            document.body.style.overflow = ''; // Allow scroll
        }
        return () => {
            document.body.style.overflow = ''; // Allow scroll on unmounting
        };
    }, [state.isSuccessModalVisible]);
    const handleOk = () => {
        setState(Object.assign(Object.assign({}, state), { isSuccessModalVisible: false }));
        resetState();
    };
    return (React.createElement(React.Fragment, null, state.isSuccessModalVisible ? (React.createElement("div", { className: Styles.modalWrap },
        React.createElement("div", { className: Styles.modal, onClick: e => e.stopPropagation() },
            React.createElement("div", { className: Styles.modalContent },
                React.createElement("div", { className: Styles.icon },
                    React.createElement(IconCircleCheck2, null)),
                React.createElement("div", { className: Styles.title, "data-testid": "email-verified-msj" }, "Email Invitation Sent to"),
                React.createElement("div", { className: Styles.successEmail, "data-testid": "email-verified" }, formState.email),
                React.createElement("div", { className: Styles.continue },
                    React.createElement(ButtonKVBase, { type: 'button', onClick: handleOk, className: Styles.submitButton, testId: "continue-verified-button", btnBackgroundGradient: "" },
                        React.createElement("div", { className: Styles.buttonContent }, "OK"))))))) : null));
};
export default SuccessModal;
